import { render } from "./MaintenanceIndex.vue?vue&type=template&id=001fa56e"
import script from "./MaintenanceIndex.vue?vue&type=script&lang=js"
export * from "./MaintenanceIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__